<template>
  <transition name="lb">
    <div
      v-if="open"
      class="lb"
      role="dialog"
      aria-modal="true"
      :aria-label="title"
      @click.self="close"
    >
      <button class="lb-close" aria-label="Close" @click="close">✕</button>

      <div class="lb-head">
        <span class="lb-title">{{ title }}</span>
        <span class="lb-count">{{ index + 1 }} / {{ images.length }}</span>
      </div>

      <button
        v-if="images.length > 1"
        class="lb-nav lb-prev"
        aria-label="Previous image"
        @click.stop="prev"
      >
        ‹
      </button>

      <figure class="lb-stage" @click.self="close">
        <!-- contain, so the whole photo is always visible and never cropped -->
        <img :src="images[index]" :alt="`${title} — image ${index + 1}`" />
      </figure>

      <button
        v-if="images.length > 1"
        class="lb-nav lb-next"
        aria-label="Next image"
        @click.stop="next"
      >
        ›
      </button>

      <div v-if="images.length > 1" class="lb-dots">
        <button
          v-for="(src, i) in images"
          :key="i"
          class="lb-dot"
          :class="{ on: i === index }"
          :aria-label="`Go to image ${i + 1}`"
          @click.stop="index = i"
        ></button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ImageLightbox",
  props: {
    open: { type: Boolean, default: false },
    images: { type: Array, default: () => [] },
    title: { type: String, default: "" },
    start: { type: Number, default: 0 },
  },
  emits: ["close"],
  data() {
    return { index: 0 };
  },
  watch: {
    open(isOpen) {
      if (isOpen) {
        this.index = Math.min(Math.max(this.start, 0), this.images.length - 1);
        document.body.classList.add("lb-open");
        window.addEventListener("keydown", this.onKey);
      } else {
        document.body.classList.remove("lb-open");
        window.removeEventListener("keydown", this.onKey);
      }
    },
  },
  unmounted() {
    // Never strand a locked page if the component goes away while open.
    document.body.classList.remove("lb-open");
    window.removeEventListener("keydown", this.onKey);
  },
  methods: {
    close() {
      this.$emit("close");
    },
    next() {
      this.index = (this.index + 1) % this.images.length;
    },
    prev() {
      this.index = (this.index - 1 + this.images.length) % this.images.length;
    },
    onKey(e) {
      if (e.key === "Escape") this.close();
      else if (e.key === "ArrowRight") this.next();
      else if (e.key === "ArrowLeft") this.prev();
    },
  },
};
</script>
